import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach's My Prospects page — gradient header, the
// search bar, then a list of prospect rows.
export default function MyProspectsSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-8">
                    <div className="mb-6"><Skeleton height={112} borderRadius={16} /></div>
                    {/* Search bar */}
                    <div className={`${cardCls} p-4 mb-6`}>
                        <Skeleton height={40} borderRadius={12} />
                    </div>
                    {/* Prospect rows */}
                    <div className="space-y-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className={`${cardCls} p-5 flex items-center justify-between`}>
                                <div className="flex items-center gap-4 flex-1">
                                    <Skeleton width={44} height={44} borderRadius={12} />
                                    <div className="flex-1">
                                        <Skeleton width="35%" height={14} />
                                        <Skeleton width="55%" height={12} className="mt-1" />
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <Skeleton width={72} height={30} borderRadius={8} />
                                    <Skeleton width={72} height={30} borderRadius={8} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
